<template>
    <div class="apprentice-simple-card">
        <div class="removable-pages-header">
            {{ $t('magazine.select_below_the_pages_which_must_be_deleted') }}
            <b-button
                class="btn-remove-fad btn-remove-pages"
                variant="danger"
                @click="onRemove()">
                {{ $t('common.delete') }}
            </b-button>
        </div>

        <div class="removable-pages">
            <div class="error">
                <b-alert
                    v-if="hasError"
                    show
                    variant="danger">
                    {{ $t('magazine.select_below_the_pages_which_must_be_deleted') }}
                </b-alert>
            </div>

            <div
                class="page-item"
                v-for="page in pages"
                :class="page.active && 'pending-removal'"
                @click="setRemove(page.id)">
                <img
                    v-if="page.thumb"
                    :src="page.thumb" />
                <div class="page-number">{{ page.order }}</div>
                <i class="btn-remove removal-icon"></i>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'design-2021-magazine-delete-pages-component',
    props: ['pagesIn', 'magazineId'],
    data() {
        return {
            pages: this.pagesIn,
            hasError: false,
        };
    },

    methods: {
        setRemove(id) {
            this.pages.forEach(function (page, key) {
                if (page.id == id) {
                    Vue.set(page, 'active', !page.active);
                }
            });

            if (this.hasError) {
                for (const page of this.pages) {
                    if (page.active) {
                        this.hasError = false;
                        break;
                    }
                }
            }
        },

        hasRemovablePages() {
            for (const page of this.pages) {
                if (page.active) {
                    this.hasError = false;
                    return true;
                }
            }

            this.hasError = true;
            return false;
        },

        onRemove() {
            if (!this.hasRemovablePages()) {
                return;
            }

            this.alert
                .confirm(
                    this.$t('magazine.delete_pages'),
                    this.$t('magazine.are_you_sure_you_want_to_delete_the_selected_pages'),
                )
                .then((confirm) => {
                    if (confirm) {
                        this.alert.saving();
                        let array = [];

                        for (const page of this.pages) {
                            if (page.active) {
                                array.push(page.id);
                            }
                        }

                        const data = {
                            pages: array,
                        };

                        this.axios.post(this.routes.magazineDeletePages(this.magazineId), data).then(
                            (response) => {
                                this.alert.success();
                                location.href = this.routes.magazine(this.magazineId);
                            }, // no action required
                            (error) => {
                                this.alert.ajaxError(error);
                            },
                        );
                    }
                });
        },
    },
};
</script>

<style scoped lang="scss">
.error {
    flex: 1 0 100%;
}

.removable-pages-header {
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: map-get($grid-gutter-spacing, 'forty-two');
}

.removable-pages {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    justify-content: flex-start;
}

.page-item {
    margin: 0 map-get($grid-gutter-spacing, 'fifteen') map-get($grid-gutter-spacing, 'twenty-one')
        map-get($grid-gutter-spacing, 'fifteen');
    position: relative;
    border: 1px solid transparent;
    width: 120px;
    height: 170px;

    img {
        width: 120px;
        height: 170px;
    }

    .page-number {
        bottom: 0;
        background: $primary;
        width: 100%;
        height: 30px;
        position: absolute;
        color: $white;
        text-align: center;
        line-height: 30px;
    }

    .removal-icon {
        opacity: 0;
        position: absolute;
        top: calc(50% - 31px);
        left: calc(50% - 20px);
        font-size: 2rem;
        color: $danger;
    }

    &:hover {
        cursor: pointer;
        border: 1px solid $danger;

        .removal-icon {
            opacity: 1;
        }

        .page-number {
            background-color: $danger;
        }
    }

    &.pending-removal {
        border: 1px solid $danger;

        .removal-icon {
            opacity: 1;
        }

        .page-number {
            background-color: $danger;
        }
    }
}

.page {
    float: left;
    margin-right: 10px;
    margin-bottom: 10px;
    width: 150px;
    cursor: pointer;
    box-shadow: 0px 0px 0px 1px #000;
    position: relative;
}

.page .pagenumber {
    bottom: 0px;
    background: rgba(80, 138, 235, 0.95);
    width: 100%;
    height: 30px;
    position: absolute;
    color: #fff;
    text-align: center;
    line-height: 30px;
}

.page.active {
    box-shadow: 0px 0px 0px 1px #ff0000;
}

.page img {
    width: 100%;
}
</style>
